import BookingsPanel from "@/components/BookingsPanel/BookingsPanel";
import HostCompanyGate from "@/components/HostCompanyGate/HostCompanyGate";
import "@/pages/MyBookingsPage/MyBookingsPage.scss";

function MyBookingsPage() {
  return (
    <div className="my-bookings-page">
      <HostCompanyGate>
        {(companyId) => <BookingsPanel companyId={companyId} />}
      </HostCompanyGate>
    </div>
  );
}

export default MyBookingsPage;
